import iconAdviser from "../../../../assets/icon_adviser.svg";

const ActionButton = ({ children, onClick, tel, number, brandId }) => {
  const commonClasses =
    `fixed right-3.5 w-16 h-16 ${brandId === "ED" ? "top-[150px]" : "top-20"} ${brandId === "ED" ? "bg-yellow-c-everyday" : "bg-purple-700"} rounded-[24px] flex flex-col items-center justify-center gap-1 z-50`;

  const Content = () => (
    <>
      <span>
        <img src={iconAdviser} alt="" />
      </span>
      <span className="text-[0.68rem] font-semibold text-white">
        {children}
      </span>
    </>
  );

  return (
    <>
      {tel ? (
        <a href={`tel:${number}`} onClick={onClick} className={commonClasses}>
          <Content />
        </a>
      ) : (
        <button className={commonClasses} onClick={onClick}>
          <Content />
        </button>
      )}
    </>
  );
};

export default ActionButton;
